/* eslint-disable no-undef */
import * as zoid from 'zoid/dist/zoid.frameworks';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getTargetUrl(_isExternal = false) {
  return '';
}

var dimensions = {
  width: '100%',
  height: '80vh',
};

var CustomerSearch = zoid.create({
  tag: 'customer-search',
  // url is only required for integrator side
  url: '/helio/search',
  dimensions: dimensions,
  autoResize: {
    width: false,
    height: false,
  },
  attributes: {
    iframe: {
      scrolling: 'no',
    },
  },
  props: {
    countryCode: {
      type: 'string',
      required: true,
    },
    marketingBrand: {
      type: 'string',
      required: false,
    },
    firstName: {
      type: 'string',
      required: false,
    },
    lastName: {
      type: 'string',
      required: false,
    },
    email: {
      type: 'string',
      required: false,
    },
    phone: {
      type: 'string',
      required: false,
    },
    profileId: {
      type: 'string',
      required: false,
    },
    onSearchReturn: {
      type: 'function',
      required: true,
    },
    closeDialog: {
      type: 'function',
      required: true,
    },
  },
});

var CustomerSearchExternal = zoid.create({
  tag: 'customer-search-external',
  // url is only required for integrator side
  url: getTargetUrl(true) + '/helio/search',
  dimensions: dimensions,
  autoResize: {
    width: false,
    height: false,
  },
  attributes: {
    iframe: {
      scrolling: 'no',
    },
  },
  props: {
    countryCode: {
      type: 'string',
      required: true,
    },
    marketingBrand: {
      type: 'string',
      required: false,
    },
    firstName: {
      type: 'string',
      required: false,
    },
    lastName: {
      type: 'string',
      required: false,
    },
    email: {
      type: 'string',
      required: false,
    },
    phone: {
      type: 'string',
      required: false,
    },
    profileId: {
      type: 'string',
      required: false,
    },
    onSearchReturn: {
      type: 'function',
      required: true,
    },
    closeDialog: {
      type: 'function',
      required: true,
    },
  },
});

var EditProfile = zoid.create({
  tag: 'edit-profile',
  // url is only required for integrator side
  url: getTargetUrl() + '/helio/profile/edit',
  dimensions: dimensions,
  autoResize: {
    width: false,
    height: false,
  },
  attributes: {
    iframe: {
      scrolling: 'no',
    },
  },
  props: {
    countryCode: {
      type: 'string',
      required: true,
    },
    marketingBrand: {
      type: 'string',
      required: false,
    },
    profileId: {
      type: 'string',
      required: true,
    },
    onEditReturn: {
      type: 'function',
      required: true,
    },
    closeDialog: {
      type: 'function',
      required: true,
    },
  },
});

var EditProfileExternal = zoid.create({
  tag: 'edit-profile-external',
  // url is only required for integrator side
  url: getTargetUrl(true) + '/helio/profile/edit',
  dimensions: dimensions,
  autoResize: {
    width: false,
    height: false,
  },
  attributes: {
    iframe: {
      scrolling: 'no',
    },
  },
  props: {
    countryCode: {
      type: 'string',
      required: true,
    },
    marketingBrand: {
      type: 'string',
      required: false,
    },
    profileId: {
      type: 'string',
      required: true,
    },
    onEditReturn: {
      type: 'function',
      required: true,
    },
    closeDialog: {
      type: 'function',
      required: true,
    },
  },
});

window['CustomerSearch'] = CustomerSearch;
window['CustomerSearchExternal'] = CustomerSearchExternal;
window['EditProfile'] = EditProfile;
window['EditProfileExternal'] = EditProfileExternal;
export { CustomerSearch, CustomerSearchExternal, EditProfile, EditProfileExternal };
